import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=784715fb"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=784715fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports